module.exports = __webpack_public_path__ + "img/hm-government-logo-white.ba3238d4.svg";